<template>

  <div>
  </div>
</template>

<script>
    export default {
        name: "message"
    }
</script>
